<template>
	<div>
		<div class="breadcrumbs padm1d2">
			<n-link :to="localePath('account')">Account</n-link>
			<span>-</span>
			<div>Orders</div>
		</div>
		<header class="flex-split">
			<h1 class="padm1d2">Your Orders</h1>
			<div v-if="false">
				<input class="order_search" type="text" placeholder="Search all orders">
				<button class="button desktop">Search Orders</button>
			</div>
		</header>
		<div class="surface padm1d2">
			<div class="order paper" v-for="(order, order_key) in orders" :key="order_key" v-show="order.products.length">
				<div class="desktop">
					<div class="header">
						<div>
							<span class="label">Order</span> #{{ order.id }}
						</div>
						<div v-if="order.order_placed">
							<span class="label">Order Placed:</span> {{ order.order_placed | date }}
						</div>
						<div v-else-if="order.date_created">
							<span class="label">Order Created:</span> {{ order.date_created | date }}
						</div>
					</div>
					<table class="products">
						<tbody>
							<tr v-for="(product, product_key) in order.products" :key="product_key">
								<td>
									<n-link :to="'/product?id=' + product.product_id" v-if="product.product_id"><img :src="product.img_src"></n-link>
									<img :src="product.img_src" v-else>
								</td>
								<td>
									<n-link :to="'/product?id=' + product.product_id" v-if="product.product_id">{{ product.name }}</n-link>
									<span v-else>{{ product.name }}</span>
									<div><currency :value="product.total"/></div>
									<div><button class="button" v-show="false">Buy it again</button></div>
								</td>
							</tr>
						</tbody>
					</table>
					<hr>
					<div class="footer flex-split">
						<div>
							<template v-if="false">
							<n-link :to="localePath('account-order') + '?id=' + order.id">Order Details</n-link>
							</template>
						</div>
						<div class="align-right">
							<currency :value="order.approved_total" v-if="order.approved_total"/>
							<currency :value="order.working_total" v-else-if="order.working_total"/>
						</div>
					</div>
				</div>
				<div class="mobile">
					<div class="header">
						Order <n-link :to="localePath('account-orders') + order.id">#{{ order.id }}</n-link>
						<div class="align-right">
							<div>{{ order.order_placed | date }}</div>
						</div>
					</div>
					<div class="products" v-for="(product, product_key) in order.products" :key="product_key">
						<div class="flex-split">
							<div class="thumbnail">
								<img :src="product.img_src" width="45px" height="45px">
							</div>
							<div>{{ product.name }}</div>
						</div>
						<div class="flex-split">
							<div>{{ product.quantity }} pieces</div>
							<div><currency :value="product.total"/></div>
						</div>
						<button class="button" v-show="false">Buy it again</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	head: {
		title: 'Your Orders'
	},
	data() {
		return {
			orders: []
		}
	},
	created() {
		this.oa_fetch('orders', {
			action:'get_all'
		} ).then( response => {
			this.orders = response.orders;
		} );
	},
	beforeCreate() {
		if ( this.$store.state.session.signed_in == false ) {
			this.$router.push('/auth')
		}
	}
}
</script>

<style scoped>
button {
	margin: 2px 0;
}
header {
	flex-wrap: wrap;
	margin: 18px 0;
}
header > * {
	width: 100%;
}
.order_search {
	width: 100%;
}
h1 {
	margin: 0;
}
.order {
	margin: 20px 0;
}
.order .header {
	display: flex;
	justify-content: space-between;
	padding: 20px;
	background-color: #fafafa;
	border-bottom: 1px solid #eee;
	font-size: 12px;
}
.products {
	width: 100%;
	padding: 20px;
}
.products td {
	padding: 10px 20px;
}
.products td:first-child {
	width: 220px;
}
.products td:last-child {
	width: 220px;
}
.products > td {
	flex-grow: 1;
}
.thumbnail {
	text-align: center;
}
.thumbnail > img {
	height: 100%;
	max-height: 180px;
}
.mobile .products > div {
	margin: 2px 0;
}
.mobile button {
	width: 100%;
}
.footer {
	padding: 20px;
}
.label {
	color: #888;
}
@media (min-width: 768px) {
	header {
		flex-wrap: none;
	}
	header > * {
		width: auto;
	}
	.order_search {
		width: auto;
	}
}
</style>
